import Cookies from 'js-cookie'

var cookiesUse = Cookies.get('cookies-use');

if (!cookiesUse) {
    setTimeout(function () {
        $('#cookies-warning').fadeIn('slow');
    }, 2500);
} else {
    $('#cookies-warning').remove();
}

$('#cookies-warning [data-remove]').click(function () {
    Cookies.set('cookies-use', 'επληροφορήθην', {
        expires: 30
    });

    $("#cookies-warning").fadeOut(function () {
        $(this).remove();
    });
});